import Reveal from "react-reveal/Reveal";
import { HelpItem } from "./HelpItem";

import { StyledContainer, Title, List } from "./styles";

export function HelpSection({ items }) {
  return (
    <Reveal>
      <StyledContainer>
        <Title>If your costs are going up and budgets squeezed, we can help.</Title>
        <List>
          {items.map(({ id, color, title, description, url, icon }) => (
            <HelpItem
              key={id}
              color={color}
              title={title}
              description={description}
              url={url}
              icon={icon}
            />
          ))}
        </List>
      </StyledContainer>
    </Reveal>
  );
}